import { IGrpStandardPageConfig } from "../../../shared/interfaces/IPageConfig";
import { IZonesUseOccupation } from "../../../shared/interfaces/IZonesUseOccupation";

export const Config: IGrpStandardPageConfig<IZonesUseOccupation> = {
    api: { path: "zoning-use-occupation" },
    fields: {
        id: {
            label: "ID",
            fieldType: "number",
        },
        zonas_use_occupation_nome: {
            label: "Nome do índice urbanístico",
            fieldType: "text",
        },
        zonas_use_occupation_valor: {
            label: "Valor",
            fieldType: "text",
        },
        zonas_use_occupation_observacao: {
            label: "Observação",
            fieldType: "text",
        },
        zonas_use_occupation_ordem: {
            label: "Ordem de exibição",
            fieldType: "text",
        },
        idzoneamento: {
            label: "ID do zoneamento",
            fieldType: "number",
        },
        zoning: {
            label: "coligacao",
            fieldType: "relation",
            fields: [
                {
                    label: "Nome Zoneamento",
                    fieldType: "text",
                    key: "idzoneamento",
                },
            ],
        },
    },
};
